import { uploadImage, removeImage } from "../../../utils/uploadImage";
import { deleteFromDB } from "../../../utils/menuFormHandler";

export async function updateWithImage(params) {
	const { data, handleProgress, parentMenuDB, categoriesArray, handleLoading, nameDB } = params;
	handleLoading(true);
	try {
		const { ref, url } = await uploadImage(data.imgUrl[0], `${nameDB}/categories`, handleProgress);
		const newCategory = { imgUrl: url, reference: ref, name: data.name };
		const categoriesUpdated = [
			...categoriesArray.slice(0, data.position),
			newCategory,
			...categoriesArray.slice(data.position),
		];
		await parentMenuDB.set(
			{
				categories: categoriesUpdated,
			},
			{ merge: true }
		);
	} catch (error) {
		alert(error);
	}
	handleLoading(false);
}

export async function deleteWithImage({ data, handleProgress, parentMenuDB, categoriesArray, handleLoading }) {
	const confirmedChange = window.confirm(
		"Se Eliminaran todos los platillos relacionados a esta categoria, desea continuar?"
	);
	if (!confirmedChange || !data.category) return;

	handleLoading(true);
	try {
		handleProgress("Preparando informacion", 0);
		const { category } = data;

		const newCategories = categoriesArray.filter(({ name }) => name !== category);
		const { reference } = categoriesArray.find(({ name }) => name === category);
		const db = parentMenuDB.collection("actual");
		let documentsToDelete = [];

		await db
			.where("category", "==", category)
			.get()
			.then((docs) => {
				docs.forEach((doc) => {
					documentsToDelete = [...documentsToDelete, { id: doc.id, data: doc.data() }];
				});
			});

		for (let { id, data } of documentsToDelete) {
			handleProgress(`Eliminando ${data.name}`, 0);
			await deleteFromDB({ db, id, data });
			handleProgress(`Eliminando ${data.name}`, 100);
		}

		handleProgress("Actualizando categorias", 0);
		await removeImage(reference);
		await parentMenuDB.update({ categories: newCategories });
		handleProgress("Actualizando categorias", 100);
	} catch (error) {
		console.log(error);
	}
	handleLoading(false);
}

export async function editWithImage(params) {
	const { data, handleProgress, parentMenuDB, categoriesArray, handleLoading, nameDB } = params;
	const confirmedChange = window.confirm("Se cambiaran todos los Menu relacionados a esta categoria, desea continuar?");
	if (!confirmedChange || !data.category) return;
	handleLoading(true);
	try {
		handleProgress("Preparando informacion", 0);
		const { name, category, position = 9999 } = data;
		const currentCategory = categoriesArray.find(({ name }) => name === category);
		const categoriesArrayFiltered = categoriesArray.filter(({ name }) => name !== category);
		const imgExists = Boolean(data?.imgUrl[0]);

		const didNameChanged = name !== currentCategory.name;

		let feed = { name };
		if (imgExists) {
			handleProgress("Eliminando imagen actual", 50);
			await removeImage(currentCategory.reference);
			handleProgress("Subiendo nueva imagen", 0);
			const { ref, url } = await uploadImage(data.imgUrl[0], `${nameDB}/categories`, handleProgress);
			feed = { ...feed, reference: ref, imgUrl: url };
		} else {
			feed = { ...feed, reference: currentCategory.reference, imgUrl: currentCategory.imgUrl };
		}

		if (didNameChanged) {
			const db = parentMenuDB.collection("actual");
			let documentsToEdit = [];
			await db
				.where("category", "==", category)
				.get()
				.then((docs) => {
					docs.forEach((doc) => {
						documentsToEdit = [...documentsToEdit, { id: doc.id, data: doc.data() }];
					});
				});
			for (let { id, data } of documentsToEdit) {
				handleProgress(`Actualizando ${data.name}`, 0);
				await db.doc(id).update({ category: name });
				handleProgress(`Actualizando ${data.name}`, 100);
			}
		}

		const categoriesUpdated = [
			...categoriesArrayFiltered.slice(0, position),
			feed,
			...categoriesArrayFiltered.slice(position),
		];
		handleProgress("Actualizando categorias", 0);
		await parentMenuDB.update({ categories: categoriesUpdated });
		handleProgress("Actualizando categorias", 100);
	} catch (error) {
		console.log(error);
	}
	handleLoading(false);
}
